import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BasicInformation from './BasicInformation';
import { profileDto } from '../../../api/Dtos/profileDto';
import ServicesOffered from './ServicesOffered';
import LeaderShipTeam from './LeaderShipTeam';
import CenterAndLocation from './CenterAndLocation';
import BasicCompanyInfo from './BasicCompanyInfo';
import AuthorInfo from './AuthorInfo';
import { useLoader } from '../../../Loader/LoaderContext';
import { API_ENDPOINTS } from '../../../api';
import { getService } from '../../../servce/ApisService';

function CompanyPreview() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
     const [searchParams] = useSearchParams();
          const leadId = searchParams.get("leadId");
          const vendorId = searchParams.get("vendorId");
          const names =searchParams.get('name');
          
     const { setLoading } = useLoader();
    const [data,setData]=useState<any | null>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;
    const users = () => {
      if (path === "/portals/leads/viewUser/previewCompany") {
        navigate("/portals/leads/viewUser"); // Navigate to viewUser for Leads
    }else if(path === "/portals/proposals/viewProposal/previewCompany"){
      navigate("/portals/proposals/viewProposal");
    }else if(path === "/portals/vendors/activeVendor/previewCompany"){
      navigate("/portals/vendors/activeVendor");
    }else if( path === "/portals/vendors/inActiveVendor/previewCompany"){
      navigate("/portals/vendors/inActiveVendor");
    }else if(path === "/portals/bookings/viewBooking/previewCompany"){
      if(names == 'booked'){
        navigate("/portals/bookings/viewBooking");
      }else {
        navigate("/portals/bookings/confirmedBooking");
      }
    }else if(path === "/portals/bookings/confirmedBooking/previewCompany"){
        navigate("/portals/bookings/confirmedBooking");
    }
    else if(path === "/portals/enquiries/contactUs/previewCompany"){
navigate('/portals/enquiries/contactUs')
    }else if( path === "/portals/enquiries/posts/previewCompany"){
      navigate("/portals/enquiries/posts")
    }else if( path === "/portals/enquiries/events/previewCompany"){
      navigate("/portals/enquiries/events")
    }else if(path === '/portals/enquiries/vendors/previewCompany'){
      navigate('/portals/enquiries/vendors')
    }
        // if (path === "/portals/leads/viewUser/previewHospital") {
             // Navigate to viewUser for Leads
        // }
    };
     useEffect(() => {
            const initializeData = async () => {
              setLoading(true);
              try {
                await fetchDetails();
                // await fetchMtCurrencyData();
              } catch (error) {
                console.error("Error during initialization:", error);
              } finally {
                setLoading(false);
              }
            };
          
            initializeData();
          }, []);
       const fetchDetails = async () => {
            try {
              let url:any;
              if(path ==='/portals/enquiries/contactUs/previewCompany' || path === '/portals/enquiries/posts/previewCompany' ||vendorId ){
               url = API_ENDPOINTS.getCompanyProfile+"?vendorId="+vendorId
              }else{
              url =  API_ENDPOINTS.getCompanyProfile+"?leadId="+leadId
              }
              const response = await getService(url); // Fetch post details using 'id'
        setData(response.data);
        const res =response.data;
        setTimeout(() => {
          setLoading(false); // Stop loader in case of error
          // setIsLoading(false);
        }, 500);
        // setEvents(response.data.leaderShipTeamDtos);
        // setEvents1(response.data.hospitalCenterReqDtos)
       
            } catch (error) {
              console.error("Error fetching post details:", error);
              setTimeout(() => {
                setLoading(false); // Stop loader in case of error
                // setIsLoading(false);
              }, 500);
            }
          };
          const onEdit=()=>{
            if (path === "/portals/leads/viewUser/previewCompany") {
              navigate("/portals/leads/viewUser/editCompany?leadId="+leadId);  // Navigate to viewUser for Leads
            } else if(path === "/portals/proposals/viewProposal/previewCompany"){
              navigate("/portals/proposals/viewProposal/editCompany?leadId="+leadId);
            }else if(path === "/portals/vendors/activeVendor/previewCompany"){
              navigate("/portals/vendors/activeVendor/editCompany?leadId="+leadId);
            }else if( path === "/portals/vendors/inActiveVendor/previewCompany"){
              navigate("/portals/vendors/inActiveVendor/editCompany?leadId="+leadId);
            }else if(path === "/portals/bookings/viewBooking/previewCompany"){
              if(names == 'booked'){
                navigate("/portals/bookings/viewBooking/editCompany?name="+names+"&leadId="+leadId);
              }else {
                navigate("/portals/bookings/confirmedBooking/editCompany?name="+'confirmed'+"&leadId="+leadId);
              }
            }else if(path === "/portals/bookings/confirmedBooking/previewCompany"){
              
                navigate("/portals/bookings/confirmedBooking/editCompany?name="+'confirmed'+"&leadId="+leadId);
              
            }
           
        }
    
    return (
        <div className="h-full py-2 w-full">
            <div className="flex items-center cursor-pointer mb-4">
                <h2
                    className="mr-2 text-gray-700 font-semibold text-sm"
                    onClick={users}
                >
                   {path === "/portals/proposals/viewProposal/previewCompany" ? 'Proposal' : path === "/portals/vendors/activeVendor/previewCompany" || path === "/portals/vendors/inActiveVendor/previewCompany" ? 'Vendors'
                   :
                  ( path === "/portals/bookings/viewBooking/previewCompany" || path ==='/portals/bookings/confirmedBooking/previewCompany') ? ' Booked' : path === "/portals/enquiries/contactUs/previewCompany" ? 'Enquiries' :
                   ( path === "/portals/enquiries/contactUs/previewCompany" ||  path === "/portals/enquiries/posts/previewCompany"  || path === "/portals/enquiries/events/previewCompany" ) ? 'Enquiries' : 
                   path === '/portals/enquiries/vendors/previewCompany' ? 'Enquiries' :
                   'Leads'} 
                </h2>{" "}

                <img src="/images/arrowIcons.svg" className="mr-2" />{" "}
                <span className="text-gray-400 font-semibold text-sm">
                {path === "/portals/proposals/viewProposal/previewCompany" ? 'Proposal' : path === "/portals/vendors/activeVendor/previewCompany" || path === "/portals/vendors/inActiveVendor/previewCompany" ? 'Vendors' :
                 path === "/portals/bookings/viewBooking/previewCompany" && names ==='booked'  ? 'View Booked' :  (path === "/portals/bookings/viewBooking/previewCompany"  || path ==='/portals/bookings/confirmedBooking/previewCompany') && names ==='confirmed' ? 'View Confirmed' : path === "/portals/enquiries/contactUs/previewCompany" ? 'Contact Us' :
                 path === "/portals/enquiries/contactUs/previewCompany" ? 'Contact Us' :
                 path === "/portals/enquiries/posts/previewCompany"  ? 'Posts' :
                 path === "/portals/enquiries/events/previewCompany"  ? 'Events' :
                 path === '/portals/enquiries/vendors/previewCompany' ?  'Vendors' :
                 'Leads'} 
                </span>
            </div>
            <div className='flex justify-between w-full'>
                <div className='flex items-center mb-2'>
                    <img src='/images/back.svg' className='mr-2 cursor-pointer' onClick={users} />
                    <h1 className="text-2xl font-bold text-[#2D2E2F] mr-3"> {path === "/portals/proposals/viewProposal/previewCompany" ? 'View Proposal' : path === "/portals/vendors/activeVendor/previewCompany" || path === "/portals/vendors/inActiveVendor/previewCompany" ? 'View Vendors': 
                     path === "/portals/bookings/viewBooking/previewCompany" && names ==='booked'  ? 'View Booked' : ( path === "/portals/bookings/viewBooking/previewCompany" || path ==='/portals/bookings/confirmedBooking/previewCompany') && names ==='confirmed' ? 'View Confirmed' : (path === "/portals/enquiries/contactUs/previewCompany"  || path === '/portals/enquiries/vendors/previewCompany' )? 'View Company' :
                     ( path === "/portals/enquiries/contactUs/previewCompany" ||  path === "/portals/enquiries/posts/previewCompany"  || path === "/portals/enquiries/events/previewCompany" ) ? 'View Company' :
                     
                     'View Leads'} </h1>
                </div>
                {
                 ((userInfo?.roles !=='PUBLISHER' &&  userInfo?.roles !=='CONTENT_ADMIN' && userInfo?.roles !=='CHIEF_EDITOR') && (path !== "/portals/enquiries/contactUs/previewCompany" && path !== "/portals/enquiries/events/previewCompany" && path !== "/portals/enquiries/posts/previewCompany" && path !== '/portals/enquiries/vendors/previewCompany')) &&
                <div className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4 cursor-pointer' onClick={onEdit}><span className='mr-2'><img src='/images/Edit_Pencil.svg' /></span>Edit</div>
}
            </div>
            <div>
                <BasicCompanyInfo submittedData={data}/>
                {
                  data?.authorDtos && data?.authorDtos?.length >0 &&
                
                <AuthorInfo submittedData={data}/>}
            </div>
          

        </div>
    )
}

export default CompanyPreview
